module.exports = __webpack_public_path__ + "files/34b829ca976c1ff478e757839a8b69f3.svg";